import * as React from 'react';
import styled, { keyframes } from 'styled-components';

const rotateAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  30% {
    transform: rotate(360deg);
  }
  30%, 100% {
    transform: rotate(360deg);
  }
`;

const scaleAnimation = keyframes`
  0% {
    transform: scale(1);
  }
  15% {
    transform: scale(1.1);
  }
  30% {
    transform: scale(0.92);
  }
  30%, 100% {
    transform: scale(1);
  }
`;

const ANIMATION_DURATION = '4s';
const ANIMATION_DELAY = '2s';
const ANIMATION_TIMING = 'ease-out';

const Corners = styled.g<{ $animate: boolean }>`
  transform-origin: center;
  transform-box: fill-box;
  animation: ${(props) => (props.$animate ? scaleAnimation : 'none')} ${ANIMATION_DURATION}
    ${ANIMATION_TIMING} ${ANIMATION_DELAY} infinite;
`;

const Cube = styled.g<{ $animate: boolean }>`
  transform-origin: center;
  transform-box: fill-box;
  animation: ${(props) => (props.$animate ? rotateAnimation : 'none')} ${ANIMATION_DURATION}
    ${ANIMATION_TIMING} ${ANIMATION_DELAY} infinite;
`;

interface ARIconProps extends React.SVGProps<SVGSVGElement> {
  animate?: boolean;
}

const ARIcon: React.FC<ARIconProps> = ({ animate = true, ...props }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Corners $animate={animate}>
      <path
        d="M6.46154 1.84615C6.46154 2.31323 6.08246 2.69231 5.61538 2.69231H4.10256C3.32523 2.69231 2.69231 3.32523 2.69231 4.10256V5.61538C2.69231 6.08246 2.31323 6.46154 1.84615 6.46154C1.37908 6.46154 1 6.08246 1 5.61538V4.10256C1 2.39108 2.39108 1 4.10256 1H5.61538C6.08246 1 6.46154 1.37908 6.46154 1.84615ZM19.8974 1H18.3846C17.9175 1 17.5385 1.37908 17.5385 1.84615C17.5385 2.31323 17.9175 2.69231 18.3846 2.69231H19.8974C20.6748 2.69231 21.3077 3.32523 21.3077 4.10256V5.61538C21.3077 6.08246 21.6868 6.46154 22.1538 6.46154C22.6209 6.46154 23 6.08246 23 5.61538V4.10256C23 2.39108 21.6089 1 19.8974 1ZM22.1538 17.5385C21.6868 17.5385 21.3077 17.9175 21.3077 18.3846V19.8974C21.3077 20.6748 20.6748 21.3077 19.8974 21.3077H18.3846C17.9175 21.3077 17.5385 21.6868 17.5385 22.1538C17.5385 22.6209 17.9175 23 18.3846 23H19.8974C21.6089 23 23 21.6089 23 19.8974V18.3846C23 17.9175 22.6209 17.5385 22.1538 17.5385ZM5.61538 21.3077H4.10256C3.32523 21.3077 2.69231 20.6748 2.69231 19.8974V18.3846C2.69231 17.9175 2.31323 17.5385 1.84615 17.5385C1.37908 17.5385 1 17.9175 1 18.3846V19.8974C1 21.6089 2.39108 23 4.10256 23H5.61538C6.08246 23 6.46154 22.6209 6.46154 22.1538C6.46154 21.6868 6.08246 21.3077 5.61538 21.3077Z"
        fill="currentColor"
      />
    </Corners>
    <Cube $animate={animate}>
      <g transform="translate(5, 4.5)">
        <path
          d="M13.4548 3.55341L8.03542 0.301781C7.36479 -0.100594 6.52983 -0.100594 5.85921 0.301781L0.439833 3.55341C0.16675 3.71774 0 4.01137 0 4.33037V9.68328C0 10.4204 0.39875 11.1212 1.02708 11.4958L5.86042 14.3958C6.19875 14.6012 6.57333 14.6979 6.94792 14.6979C7.3225 14.6979 7.69708 14.6012 8.03542 14.3958L12.8687 11.4958C13.4971 11.1212 13.8958 10.4204 13.8958 9.68328V4.33037C13.8958 4.01137 13.7267 3.71774 13.4548 3.55341ZM6.79083 1.8557C6.8875 1.7977 7.00592 1.7977 7.10258 1.8557L11.2266 4.33037L7.10258 6.80503C7.00592 6.86303 6.8875 6.86303 6.79083 6.80503L2.66679 4.33037L6.79083 1.8557ZM1.95629 9.94911C1.87171 9.8887 1.81129 9.79203 1.81129 9.68328V5.93141L5.85921 8.36016C5.91721 8.3952 5.98125 8.4097 6.04046 8.43749V12.3996L1.95629 9.94911ZM12.0821 9.68328C12.0821 9.79203 12.0217 9.8887 11.9371 9.94911L7.85296 12.3996V8.43749C7.91217 8.40849 7.97742 8.39399 8.03421 8.36016L12.0821 5.93141V9.68328Z"
          fill="currentColor"
        />
      </g>
    </Cube>
  </svg>
);

export default ARIcon;
